module.exports = __webpack_public_path__ + "img/aircon.3521e186.png";